import { makeStyles } from "tss-react/mui"
import { Box, Tab, Tabs } from "@mui/material"

import { FAVORITES_GROUP_ID, TakeawayProductGroup } from "../takeawayTypes"

import { TakeawayActionButtons } from "./TakeawayActionButtons"

const useStyles = makeStyles()((theme) => ({
    wrapper: {
        display: "flex",
        alignItems: "center",
        background: theme.palette.common.white,
    },
    tabs: {
        flex: 1,
        minWidth: 0,
        "& .MuiTab-root": {
            color: theme.palette.tailwind.slate[400],
            textTransform: "none",
            padding: "1rem 1.25rem",
        },
        "& .Mui-selected": {
            fontWeight: 600,
            color: `${theme.palette.tailwind.slate[900]} !important`,
        },
        "& .MuiTabs-indicator": {
            backgroundColor: theme.palette.tailwind.slate[900],
            height: ".125rem",
        },
    },
    actions: {
        flex: "none",
        paddingRight: ".75rem",
    },
}))

type TakeawayCategoryBarProps = Readonly<{
    groups: TakeawayProductGroup[]
    activeGroupId: number | null
    showFavorites: boolean
    search: string
    onGroupChange: (groupId: number) => void
    onSearchChange: (search: string) => void
    onShowFavoritesChange: (show: boolean) => void
}>

export function TakeawayCategoryBar({
    groups,
    activeGroupId,
    showFavorites,
    search,
    onGroupChange,
    onSearchChange,
    onShowFavoritesChange,
}: TakeawayCategoryBarProps) {
    const { classes } = useStyles()

    const handleFavoritesChange = (next: boolean) => {
        onShowFavoritesChange(next)
        if (next) {
            onGroupChange(FAVORITES_GROUP_ID)
        } else {
            const firstNonFav = groups.find((g) => g.id !== FAVORITES_GROUP_ID)
            if (firstNonFav) onGroupChange(firstNonFav.id)
        }
    }

    const visibleTabs = groups.filter((g) => g.id !== FAVORITES_GROUP_ID)

    return (
        <Box className={classes.wrapper}>
            <Tabs
                value={showFavorites ? false : (activeGroupId ?? false)}
                variant="scrollable"
                scrollButtons="auto"
                className={classes.tabs}
                onChange={(_, value: number) => {
                    onShowFavoritesChange(false)
                    onGroupChange(value)
                }}
            >
                {visibleTabs.map((group) => (
                    <Tab key={group.id} label={group.name} value={group.id} />
                ))}
            </Tabs>
            <div className={classes.actions}>
                <TakeawayActionButtons
                    search={search}
                    showFavorites={showFavorites}
                    onSearchChange={onSearchChange}
                    onFavoritesChange={handleFavoritesChange}
                />
            </div>
        </Box>
    )
}
